import { LoanApplicationTabRouteParam, MAX_DOCUMENT_PANES } from 'constants/loanApplication';

import { RESET_STATE } from 'store/global/actions';

import { CONTROL_UI_ACTION_TYPE } from '../actions';

const initialState = {
  editingIds: [],
  availableTabs: {},
  activeTab: LoanApplicationTabRouteParam.PROPERTY_AND_LOAN,
  isActiveTabReFetchNeeded: false,
  isTabsDisabled: false,
  isSignalRInitiated: false,
  documentPanes: [],
  documentPaneSizes: null,
  documentPaneHostWidth: 0,
};

const controlUIReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case CONTROL_UI_ACTION_TYPE.TOGGLE_EDIT_STATE:
      return {
        ...state,
        editingIds: state.editingIds.includes(payload)
          ? state.editingIds.filter(id => id !== payload)
          : [...state.editingIds, payload],
      };

    case CONTROL_UI_ACTION_TYPE.SET_ACTIVE_TAB:
      return { ...state, activeTab: payload, editingIds: initialState.editingIds };

    case CONTROL_UI_ACTION_TYPE.SET_AVAILABLE_TABS:
      return { ...state, availableTabs: payload };

    case CONTROL_UI_ACTION_TYPE.SET_IS_ACTIVE_TAB_RE_FETCH: {
      const { triggeredByPendingChanges, isActiveTabReFetchNeeded } = payload;

      return { ...state, triggeredByPendingChanges, isActiveTabReFetchNeeded };
    }

    case CONTROL_UI_ACTION_TYPE.CLEAR_EDITING_IDS:
      return {
        ...state,
        editingIds: meta.tabName
          ? state.editingIds.filter(id => !id.startsWith(meta.tabName))
          : initialState.editingIds,
      };

    case CONTROL_UI_ACTION_TYPE.SET_IS_SIGNAL_R_INITIATED:
      return {
        ...state,
        isSignalRInitiated: payload,
      };

    case CONTROL_UI_ACTION_TYPE.OPEN_DOCUMENT_PANE: {
      if (state.documentPanes.length >= MAX_DOCUMENT_PANES) {
        return state;
      }

      return { ...state, documentPanes: [...state.documentPanes, payload] };
    }

    case CONTROL_UI_ACTION_TYPE.CLOSE_DOCUMENT_PANE: {
      const documentPanes = state.documentPanes.filter(pane => pane.paneId !== payload);

      return {
        ...state,
        documentPanes,
        documentPaneSizes: documentPanes.length ? state.documentPaneSizes : null,
      };
    }

    case CONTROL_UI_ACTION_TYPE.SET_DOCUMENT_PANE_SIZES:
      return { ...state, documentPaneSizes: payload };

    case CONTROL_UI_ACTION_TYPE.SET_DOCUMENT_PANE_HOST_WIDTH:
      return { ...state, documentPaneHostWidth: payload };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default controlUIReducer;
